import React, { useState, forwardRef, useEffect } from "react";

import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import MeaUpdateModal from "../../../../components/MeaUpdateModal";
import documentsAPI from "../../../../services/documents";

const UpdateDocumentModal = forwardRef((props, ref) => {
  //
  const [name, setName] = useState("");
  const [presentation, setPresentation] = useState("");
  //
  useEffect(() => {
    setName(props?.document?.name);
    setPresentation(props?.document?.presentation);
  }, [props]);

  //
  return (
    <>
      <MeaUpdateModal
        ref={ref}
        title="Modifier"
        schoolId={props.schoolId}
        trainingId={props.trainingId}
        serviceAPI={documentsAPI}
        id={props?.document?.id}
        data={{
          name: name,
          presentation: presentation,
        }}
      >
        <label htmlFor="name" className="block text-900 font-medium mb-2">
          Nom de la salle
        </label>
        <InputText
          id="name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full mb-3"
          autoFocus
        />
        <label
          htmlFor="presentation"
          className="block text-900 font-medium mb-2"
        >
          Présentation
        </label>
        <InputTextarea
          id="presentation"
          type="text"
          value={presentation}
          onChange={(e) => setPresentation(e.target.value)}
          rows={3}
          className="w-full mb-3"
        />
      </MeaUpdateModal>
    </>
  );
});

export default UpdateDocumentModal;
